/**
 * ScrollToTop — reset the window scroll position on every route change.
 *
 * React Router (v6) deliberately does NOT change scroll on push navigation.
 * Without this, clicking a footer link lands you on the new page but keeps
 * you scrolled wherever the previous page's footer was.
 *
 * Behaviour:
 *   · On every pathname change, scroll to (0, 0).
 *   · If the URL carries a `#anchor`, DON'T scroll — let the browser's
 *     native anchor-jump + any `scrollIntoView` on mount handle it.
 *   · POP navigation (browser back/forward) is left alone so the browser's
 *     own scroll restoration still works as users expect.
 */
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) return;              // anchor jump wins
    if (navType === "POP") return; // let the browser restore
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, navType]);

  return null;
}
